// Animated background component
import React from 'react';
import './AnimatedBackground.css';

export const AnimatedBackground = ({ variant = 'default' }) => {
  return (
    <div className={`animated-background ${variant}`}>
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="shape shape-6"></div>
      </div>
      <div className="gradient-mesh"></div>
    </div>
  );
};

export const ParticleBackground = () => {
  return (
    <div className="particle-background">
      {[...Array(30)].map((_, i) => (
        <div 
          key={i} 
          className="particle"
          style={{
            '--delay': `${Math.random() * 10}s`,
            '--duration': `${15 + Math.random() * 20}s`,
            '--x': `${Math.random() * 100}%`,
            '--y': `${Math.random() * 100}%`,
          }}
        ></div>
      ))}
    </div>
  );
};

export const GridBackground = () => {
  return (
    <div className="grid-background">
      <div className="grid-lines"></div>
      <div className="grid-overlay"></div>
    </div>
  );
};
